import { useCallback, useRef } from 'react';

/** Format an ISO string to HH:MM (locale it-IT). */
export function formatTime(iso) {
  try { return new Date(iso).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' }); } catch { return ''; }
}

/** Format day label ("Oggi", "Ieri", or "dd MMMM"). */
export function formatDay(iso) {
  try {
    const d = new Date(iso);
    const today = new Date();
    const yesterday = new Date(); yesterday.setDate(today.getDate() - 1);
    if (d.toDateString() === today.toDateString()) return 'Oggi';
    if (d.toDateString() === yesterday.toDateString()) return 'Ieri';
    return d.toLocaleDateString('it-IT', { day: '2-digit', month: 'long' });
  } catch { return ''; }
}

/**
 * useLongPress — fires `onLongPress` after ~450ms of press (touch/mouse).
 * Also fires `onContextMenu` for desktop right-click.
 */
export function useLongPress(onLongPress, delay = 450) {
  const timerRef = useRef(null);
  const triggeredRef = useRef(false);

  const start = useCallback((e) => {
    triggeredRef.current = false;
    timerRef.current = setTimeout(() => {
      triggeredRef.current = true;
      onLongPress(e);
    }, delay);
  }, [onLongPress, delay]);

  const clear = useCallback(() => { if (timerRef.current) clearTimeout(timerRef.current); }, []);

  return {
    onMouseDown: start,
    onMouseUp: clear,
    onMouseLeave: clear,
    onTouchStart: start,
    onTouchEnd: clear,
    onTouchCancel: clear,
    onContextMenu: (e) => { e.preventDefault(); onLongPress(e); },
  };
}
